import React, {useState, createContext, useContext} from 'react'
import { ManagerContext } from './ManagerContext'
import { OpenAiContext } from './OpenAiContext'
import { Alert, Snackbar } from '@mui/material'
import Login from '../components/Auth/login'
import SimpleBackdrop from '../components/SimpleBackDrop';
import AppTheme from '../shared-theme/AppTheme';
import ContactMessage from '../components/chat/ContactMessage';


import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../theme/customizations';
import { set } from 'zod'

const xThemeComponents = {
  ...chartsCustomizations,
  // ...dataGridCustomizations,
  // ...datePickersCustomizations,
  // ...treeViewCustomizations,
};

export const UiContext = createContext()


export const UiProvider = ( {children, props} ) => {
    const { } = useContext(ManagerContext)
    const { } = useContext(OpenAiContext)
    const [ loginStatus, setLoginStatus ] = useState(null);
    const [ openContact, setOpenContact ] = useState(false);
    const [ openLogin, setOpenLogin ] = React.useState(false);
    const [ openSnack, setOpenSnack ] = React.useState('');
    const [ backDrop, setBackDrop ] = React.useState(false);

    const closeBackDrop = () => {
        setBackDrop(false)
    }

    const openBackDrop = () => {
        setBackDrop(true)
    }

    const openContactForm = () => {
        setOpenContact(true)
    }
    const closeContactForm = () => {
        setOpenContact(false)
    }

    const callbackLogin = () => {
        setLoginStatus('closed')
        console.log('callbackLogin')
    }

    const value = {
        openBackDrop, closeBackDrop,
        openLogin, setOpenLogin, loginStatus,
        openSnack, setOpenSnack,
        backDrop, setBackDrop,
        openContact, setOpenContact,
        openContactForm, closeContactForm,
    }

    return (
        <AppTheme {...props} disableCustomTheme={false} themeComponents={xThemeComponents} sx={{ overflow: 'hidden' }}>
            <ContactMessage _open={openContact} _setOpen={setOpenContact} openBackDrop={openBackDrop} closeBackDrop={closeBackDrop} />
            <UiContext.Provider value={value}>
                <Login btVisible={false} _open={openLogin} _setOpen={setOpenLogin} callback={callbackLogin} />
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={openSnack!==''?true:false}
                    onClose={() => setOpenSnack('')}
                    autoHideDuration={6000}
                >
                    <Alert
                        onClose={() => setOpenSnack('')}
                        severity="success"
                        sx={{ width: '100%' }}
                    >
                    {openSnack}
                    </Alert>
                </Snackbar> 
                <SimpleBackdrop open={backDrop} setOpen={setBackDrop} />
                {children}
            </UiContext.Provider>
        </AppTheme>
    )
}